'use strict';

var _createClass = require("/vercel/path0/node_modules/@babel/runtime/helpers/createClass.js").default;
var _classCallCheck = require("/vercel/path0/node_modules/@babel/runtime/helpers/classCallCheck.js").default;
var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray.js").default;
Object.defineProperty(exports, '__esModule', {
  value: true
});
var bytes = require('../bytes.js');
var varint = require('../varint.js');
var create = function create(code, digest) {
  var size = digest.byteLength;
  var sizeOffset = varint.encodingLength(code);
  var digestOffset = sizeOffset + varint.encodingLength(size);
  var bytes = new Uint8Array(digestOffset + size);
  varint.encodeTo(code, bytes, 0);
  varint.encodeTo(size, bytes, sizeOffset);
  bytes.set(digest, digestOffset);
  return new Digest(code, size, digest, bytes);
};
var decode = function decode(multihash) {
  var bytes$1 = bytes.coerce(multihash);
  var _varint$decode = varint.decode(bytes$1),
    _varint$decode2 = _slicedToArray(_varint$decode, 2),
    code = _varint$decode2[0],
    sizeOffset = _varint$decode2[1];
  var _varint$decode3 = varint.decode(bytes$1.subarray(sizeOffset)),
    _varint$decode4 = _slicedToArray(_varint$decode3, 2),
    size = _varint$decode4[0],
    digestOffset = _varint$decode4[1];
  var digest = bytes$1.subarray(sizeOffset + digestOffset);
  if (digest.byteLength !== size) {
    throw new Error('Incorrect length');
  }
  return new Digest(code, size, digest, bytes$1);
};
var equals = function equals(a, b) {
  if (a === b) {
    return true;
  } else {
    return a.code === b.code && a.size === b.size && bytes.equals(a.bytes, b.bytes);
  }
};
var Digest = /*#__PURE__*/_createClass(function Digest(code, size, digest, bytes) {
  _classCallCheck(this, Digest);
  this.code = code;
  this.size = size;
  this.digest = digest;
  this.bytes = bytes;
});
exports.Digest = Digest;
exports.create = create;
exports.decode = decode;
exports.equals = equals;